import React from "react";
import { Box, Drawer, Divider } from "@mui/material";
import TabList from "./components/TabList";
import HeaderList from "./components/HeaderList";
import FooterList from "./components/FooterList";
import LanguageList from "./components/LanguageList";
import TimeZoneList from "./components/TimeZoneList";

interface Props {
  openSettings: boolean;
  toggleHandleSettings: () => void;
}

const SbuxSettings = ({ openSettings, toggleHandleSettings }: Props) => {
  const handleModal = () => {
    toggleHandleSettings();
  };

  return (
    <Drawer
      anchor={"right"}
      open={openSettings}
      PaperProps={{
        sx: {
          minWidth: "25%",
          overflowY: "auto",
          height: "100vh",
          display: "flex",
          flexDirection: "column",
        },
      }}
      ModalProps={{
        disableEnforceFocus: true,
        onClose: handleModal,
        disablePortal: false,
      }}
      variant="temporary"
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          height: "100%",
          flex: 1,
        }}
      >
        <Box>
          <HeaderList handleModal={handleModal} />
        </Box>

        <Divider />

        <Box>
          <LanguageList />
          <TimeZoneList />
          <TabList />
        </Box>

        <Box sx={{ minHeight: "90px" }}>
          <FooterList handleModal={handleModal} />
        </Box>
      </Box>
    </Drawer>
  );
};

export default React.memo(SbuxSettings);
